import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { SfEditor } from '../custom/custom';
import { Node, Text, Path } from 'slate';
var normalizeNode = function normalizeNode(editor) {
  var normalizeNode = editor.normalizeNode;
  editor.normalizeNode = function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      node = _ref2[0],
      path = _ref2[1];
    // if current node is a list node
    var type = node.type;
    // wrap the outest list item into unoreded list
    if (path.length === 1 && type === 'list_item') {
      SfEditor.wrapNodes(editor, {
        type: 'unordered_list',
        children: [node]
      }, {
        at: path
      });
    }
    if (type === 'ordered_list' || type === 'unordered_list') {
      var currentNodeIndex = path.slice(-1)[0];
      var previousSibling;
      if (currentNodeIndex !== 0) {
        previousSibling = Node.get(editor, Path.previous(path));
      }
      if (previousSibling && previousSibling.type === type) {
        // merge previous same type list node
        SfEditor.mergeNodes(editor, {
          at: path
        });
        currentNodeIndex = currentNodeIndex - 1;
      }
      var parentNode = Node.parent(editor, path);
      var nextIndex = currentNodeIndex + 1;
      var nextSiblings = parentNode.children[nextIndex];
      if (nextSiblings && nextSiblings.type === type) {
        // merge next same type list node
        SfEditor.mergeNodes(editor, {
          at: Path.next(path)
        });
      }
    }

    // trailing a paragrph at the end of the document
    if (path.length === 1 && path[0] === editor.children.length - 1) {
      if (node.type !== 'paragraph' || !SfEditor.isEmptyParagraph(node)) {
        SfEditor.insertNodes(editor, {
          type: 'paragraph',
          children: [{
            text: ''
          }]
        }, {
          at: [path[0] + 1]
        });
      }
    }
    if (type === 'blockquote') {
      node.children.forEach(function (child, index) {
        var childPath = [].concat(_toConsumableArray(path), [index]);
        if (child.type === 'blockquote') {
          SfEditor.unwrapNodes(editor, {
            at: childPath
          });
        }
      });
    }

    // remove empty link
    if (type === 'link') {
      if (Node.text(node) === '' && node.children.length > 0) {
        SfEditor.removeNodes(editor, {
          at: path
        });
      }
    }

    // remove mark when the text node is empty
    if (Text.isText(node) && node.text.length === 0) {
      if (Object.keys(node).length > 1) {
        SfEditor.setNodes(editor, {
          CODE: false,
          BOLD: false,
          ITALIC: false
        }, {
          at: path
        });
      }
    }
    return normalizeNode([node, path]);
  };
  return editor;
};
export default normalizeNode;